import styled from 'styled-components'

export const Wrapper = styled.div`
  transition: background 0.2s;

  &:hover {
    background-color: var(--gray-200);
  }

  &:focus {
    outline-offset: 2px;
    outline: 2px solid var(--blue);
  }
`

Wrapper.displayName = 'Wrapper'

export const List = styled.ul`
  li {
    position: relative;

    &:nth-of-type(n + 2) {
      margin-left: -0.5rem;
    }

    &:nth-of-type(2) {
      z-index: 1;
    }

    &:nth-of-type(3) {
      z-index: 2;
    }
  }
`

List.displayName = 'List'

export const Avatar = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  background-color: var(--gray-100);
`

Avatar.displayName = 'Avatar'

export const UserMention = styled.span`
  &::before {
    content: '●';
    color: var(--blue-light);
    font-size: 0.5rem;
    position: absolute;
    left: -0.65rem;
    top: 55%;
    transform: translateY(-50%);
  }
`

UserMention.displayName = 'UserMention'
